import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseErrorPage from './BaseErrorPage';
import { LocationDescriptor } from 'history';

interface IProps {
  message: string;
  parentUrl: LocationDescriptor;
  retry: () => void;
}

const ErrorPage = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <BaseErrorPage
      parentUrl={props.parentUrl}
      message={props.message}
      actionButton={<Button onClick={props.retry}>{t('actions.retry')}</Button>}
    />
  );
};

export default ErrorPage;
